import { TICKER_DATA_RECEIVED, TICKER_DATA_REQUEST, CRYPTOCURRENCY_FETCH } from '../actions/ticker';
import { COMPANY_DATA_REQUEST } from '../actions/company';

export default function tickers(state = {}, action) {
    switch (action.type) {
    case TICKER_DATA_RECEIVED:
        return Object.assign({}, state, {
            [action.symbol]: Object.assign(
                {},
                state[action.symbol] || { ready: true },
                action.data,
            ),
        });

    case TICKER_DATA_REQUEST.SUCCESS:
        if (action.payload && action.payload.key) {
            return Object.assign({}, state, {
                [action.payload.key]: Object.assign(
                    {},
                    state[action.payload.key] || { ready: true },
                    action.payload.values,
                ),
            });
        }
        return state;

    case COMPANY_DATA_REQUEST.SUCCESS:
        if (action.payload && action.meta.symbol) {
            return Object.assign({}, state, {
                [action.meta.symbol]: Object.assign(
                    {},
                    state[action.meta.symbol] || {},
                    action.payload.values,
                ),
            });
        }
        return state;

    case CRYPTOCURRENCY_FETCH.SUCCESS:
        if (action.payload && action.payload.key) {
            return Object.assign({}, state, {
                [action.payload.key]: Object.assign(
                    {},
                    state[action.payload.key] || { ready: true },
                    action.payload.values,
                ),
            });
        }
        return state;

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/tickers.js
 **/